import axios from "@/utils/axios"
import { sessionExpiryState } from '@/events/sessionExpiry'

const verifyUser = async () => {
  try {
    const response = await axios.get('/auth/user')
    
    return response.status === 'success'
  } catch (error) {
    return false
  }
}

function setupGuards(router) {
  router.beforeEach(async (to, from, next) => {

    if (to.path === '/login' || to.path === '/register' || to.path === '/' || to.path === '/auth/password-reset/forgot-password' || to.path === '/auth/password-reset/update-password' || to.path === '/auth/password-reset/verify-otp') {
      next()

      return
    }

    const isLoggedIn = await verifyUser()
    if (!isLoggedIn) {
      if (sessionExpiryState.isHandling) {
        next(false)

        return
      }

      next('/login')

      return
    }
    next()
  })
}

export default setupGuards
